import classNames from 'classnames'
import type { FunctionComponent } from 'react'

import styles from './investor-card.module.scss'
import { Image } from '@components/image'
import { Text } from '@components/text'
import type { InvestorFragment } from '@graphql/fragments/InvestorFragment.graphql'

export const InvestorCard: FunctionComponent<InvestorCardProps> = ({
    image,
    name,
    title,
    index,
}) => {
    const remainder = index % 3
    const imageClass = styles[`image-${remainder}`]

    return (
        <div className={styles.card}>
            {image?.source && (
                <Image
                    className={classNames(styles.image, imageClass)}
                    source={image.source}
                    source2x={image.source2x}
                    source3x={image.source3x}
                    contentType={image.contentType}
                    alt={image.alt}
                    lazy
                />
            )}
            <Text typeStyle='heading-xxs' tag='div'>
                <span className={styles.investorHeading}>{name}</span>
            </Text>
            <Text typeStyle='body-xs' color='dim' tag='div'>
                {title}
            </Text>
        </div>
    )
}

export default InvestorCard

export interface InvestorCardProps
    extends Omit<InvestorFragment, 'sys' | 'type'> {
    index: number
}
